import angular from 'angular';
import './navigation-menu';
import './navigation-profile';
import './navigation-favorites';
import './navigation-search';

angular.module('folkeuni').component('mobileNavigation', {
	bindings: {
		currentPageId: '@'
	},
	controller: function ($window, $element, $scope) {
		var $ctrl = this;
		$ctrl.navigationActive = false;
		$ctrl.activeTab = null;
		$ctrl.minimizedHeader = false;

		$ctrl.toggleTab = function (tabName) {
			if ($ctrl.activeTab == tabName) {
				$ctrl.closeTab();
			} else {
				$ctrl.activateTab(tabName);
			}
		};

		$ctrl.activateTab = function (tabName) {
			$ctrl.navigationActive = true;
			$ctrl.activeTab = tabName;
			$ctrl.minimizedHeader = true;
			angular.element(document.body).addClass('noscroll');
		};

		$ctrl.closeTab = function () {
			$ctrl.navigationActive = false;
			$ctrl.activeTab = null;
			if ($window.scrollY < 90 && $ctrl.minimizedHeader) {
				$ctrl.minimizedHeader = false;
			}
			angular.element(document.body).removeClass('noscroll');
		};

		angular.element($window).bind('scroll', function (evt) {
			if ($window.scrollY >= 90 && !$ctrl.minimizedHeader) {
				$ctrl.minimizedHeader = true;
				$scope.$apply();
			} else if ($window.scrollY < 90 && $ctrl.minimizedHeader) {
				if (!$ctrl.navigationActive) {
					$ctrl.minimizedHeader = false;
				}
				$scope.$apply();
			}
		});

		$scope.$on('activateMenu', function (e, data) {
			$ctrl.activateTab('menu');
		});
	},
	template: '<ng-transclude></ng-transclude>',
	transclude: true
});
